import { IUser } from '../../../slices/users/user';

export const getDigitsOnly = (value: string): string => {
  return `${value.replace(/\D/g, '')}`;
};

export const getCharactersNotNumericOnly = (value: string): string => {
  return `${value.replace(/\b\d+\b/g, '')}`;
};

type UserNames = Pick<IUser, 'firstName' | 'lastName'>;

export const getUserInitials = (user: UserNames): string => {
  const { firstName = '', lastName = '' } = user;
  return `${firstName.trim()[0] ?? ''}${lastName.trim()[0] ?? ''}`
    .toUpperCase();
};

export const capitalizeFirstLetter = (text: string): string => {
  return text.charAt(0).toUpperCase() + text.toLowerCase().slice(1);
};

export const isValidString = (text: string): boolean => {
  return !!text.trim();
};

export const updateQueryStringParameter = (uri: string, key: string, value: string): string => {
  const regex = new RegExp('([?&])' + key + '=.*?(&|$)', 'i');
  const separator = uri.indexOf('?') !== -1 ? '&' : '?';
  if (uri.match(regex)) {
    return uri.replace(regex, '$1' + key + '=' + value + '$2');
  }
  return uri + separator + key + '=' + value;
};

export const truncate = (text: string, limit = 40, omission = '...'): string => {
  const trimmedText = String(text).trim();
  if (trimmedText.length > limit) {
    return `${trimmedText.substring(0, limit - omission.length).trim()}${omission}`;
  }
  return trimmedText;
};